
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[qrCode]",
      function () {
        return require("private-next-pages/[qrCode]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[qrCode]"])
      });
    }
  